import token, { tokenToVars } from '../token';
import Table from './table';

export { Table };
export default tokenToVars(Table, token);
